export const appStoreFeatureKey = 'appStore';
